<h2>{{header}}</h2>
<mat-dialog-content>
  <p [innerHTML]="message"></p>
  <div class="form-group">
    <label>Choose a date</label>
    <app-utc-date-picker [min]="todaysDate" [(ngModel)]="chosenDate"></app-utc-date-picker>
    @if (chosenDate) {
      <p [innerHTML]="warning" [class.error]="chosenDate" style="margin-top: 10px;"></p>
    }
  </div>
</mat-dialog-content>
<div class="dialog-buttons">
  <div style="display:flex">
    <button [disabled]="!chosenDate" (click)="save()" class="btn btn-primary btn-round btn-round-sm" mat-dialog-close>
      <i class="fa fa-save"></i>
      <div style="font-weight:normal">Save</div>
    </button>
    <div style="flex-grow: 1"></div>
    <button (click)="cancel()" class="btn btn-primary btn-round btn-round-sm">
      <i class="fa fa-close"></i>
      <div style="font-weight:normal">Cancel</div>
    </button>

  </div>

</div>